var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-list__tab"},[_c('div',{staticClass:"d-block-xl"},[_c('transition',{staticClass:"r",attrs:{"name":"swipe-left","tag":"div"}},[_c('div',{staticClass:"services"},_vm._l((_vm.services),function(service){return _c('Service',{key:service.id,attrs:{"service":service,"disabled":(!_vm.myFinishedFlats || _vm.myFinishedFlats.length === 0) && service.metricKey === 'reg_pravo' || 
                      service.metricKey === 'zapic' && !_vm.myFlats.some(function (flat) { return flat.buildingState === 'Сдан'; }),"onClick":function () {
            switch (service.metricKey) {
              case 'reg_pravo':
                _vm.setPPDAndTPDConfirmModalOpen(true);
                return;
              case 'zapic':
                _vm.getBasisWidgetToken();
                return;
              default:
                _vm.setServiceModalOpen(true); 
                return;
            }
            _vm.sendToMetrics(service.metricKey)}}})}),1)])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }